module.exports = __webpack_public_path__ + "media/assets/images/flags/ar-b72521e3fe02348b3cc2d76a14315cf7.svg";